import IconNewWindow from '@picsart/icons/IconNewWindow';
import { useTranslation } from 'react-i18next';

import analytics from '../../services/analytics';

import useStyles from './styles';

export default function GenerateTextBanner() {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <a
      className={classes.root}
      href="/text/ai-writer/create/"
      target="_blank"
      rel="noreferrer"
      onClick={() => {
        analytics.gaEvent('page_click', {
          page_path: window.location.pathname,
          action_type: 'generate_more_text_withAI',
        });
      }}
    >
      <div className={classes.container}>
        <span>{t('generate.banner01')}</span>
        <span className={classes.text02}>{t('generate.banner02')}</span>
        <IconNewWindow className={classes.icon} />
      </div>
    </a>
  );
}
